module.exports = __webpack_public_path__ + "media/authors/kathryn-knight-randolph-square-2090b029.jpg";